<ng-template #content let-offcanvas>
    
    <div class="offcanvas-body">
        <div class=" container pt-3">

            <div class="row">
                <div class=" col-12 col-md-12 ">
                    <app-new-fee (close)="close()" [code_edit]="code_edit"></app-new-fee>
                </div>
            </div>
        </div>
    </div>
</ng-template>





<div class="mt-md-3 p-3">

    <div class="row ">
        <div class=" col-12 col-md-10 offset-md-1">

            <h5 class=" text-secondary   text-center"> Penalidades

               
            </h5>
            <div data-rbac-permiso="config.comisiones.create" class="mb-5 mt-2 text-center" *ngIf="_auth.hasPermission('config.comisiones.create') || _auth.hasAccessOrProfile('finanzas', ['OWNER'])">
                <button (click)="addForm(content)" class="btn btn-block btn-primary ">
                <span>Nueva Penalidad</span>
                <!-- <span *ngIf="submit_disabled">
                  <i class="fa  fa-spinner fa-spin ms-2"></i>
                </span> -->
              </button>
            </div>
           
            <ng-container *ngIf="!plans_loading" class="pt-4">

                <!-- Filtros de estado mejorados -->
                <div class="row mb-4">
                    <div class="col-12">
                        <div class="card border-0 bg-light">
                            <div class="card-body p-3">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                    </div>
                                    <div class="btn-group" role="group">
                                        <input type="radio" 
                                               class="btn-check" 
                                               name="statusFilter" 
                                               id="activeOnly" 
                                               [checked]="status_plans === false"
                                               (change)="status_plans = false">
                                        <label class="btn btn-outline-success btn-sm" for="activeOnly">
                                            <i class="fas fa-check-circle me-1"></i>
                                            Activos
                                        </label>

                                        <input type="radio" 
                                               class="btn-check" 
                                               name="statusFilter" 
                                               id="showAll" 
                                               [checked]="status_plans === true"
                                               (change)="status_plans = true">
                                        <label class="btn btn-outline-secondary btn-sm" for="showAll">
                                            <i class="fas fa-list me-1"></i>
                                            Todos
                                        </label>
                                    </div>
                                </div>
                                
                                <!-- Contador de resultados -->
                                <div class="mt-2 text-end">
                                    <small class="text-muted">
                                        <ng-container *ngIf="status_plans === false">
                                            Mostrando {{ getActiveFeesCount() }} penalidades activas
                                        </ng-container>
                                        <ng-container *ngIf="status_plans === true">
                                            Mostrando {{ plans?.length || 0 }} penalidades en total
                                        </ng-container>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class=" mt-4 row">
                    <div [ngClass]="{'d-none': shouldHideFee(item), 'inactive-div': item?.paused }" *ngFor="let item of plans" class="col-12 col-md-6">
                        <div class="card mb-4"  style="min-height: 200px;" >
                            <div class="card-body">

                            <!-- Header con código, fecha y botones de acción -->
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <!-- Sección izquierda: Código -->
                                <div class="d-flex align-items-center">
                                    <span class="text-secondary small fw-bold" style="font-size: 10px;">
                                        {{item?.code}}
                                    </span>
                                </div>
                                
                                <!-- Sección derecha: Fecha y botones de acción -->
                                <div class="d-flex align-items-center">
                                    <!-- Fecha -->
                                    <div class="text-secondary small me-3" style="font-size: 11px;">
                                        {{item?.created_at | date: 'dd/MM/yyyy'}}
                                    </div>
                                    
                                    <!-- Botón historial de versiones - Oculto temporalmente -->
                                    <!-- <button (click)="openVersionTimeline(item?.code_concept)"
                                            class="btn btn-sm btn-outline-info p-1 me-2"
                                            title="Ver historial de versiones"
                                            style="font-size: 12px;">
                                        <i class="fas fa-history"></i>
                                    </button> -->
                                    
                                    <!-- Botón editar -->
                                    <button data-rbac-permiso="config.comisiones.update" *ngIf="_auth.hasPermission('config.comisiones.update') || _auth.hasAccessOrProfile('finanzas', ['OWNER'])" 
                                            (click)="edit(content, item?.code)"
                                            class="btn btn-sm btn-outline-primary p-1 me-2"
                                            title="Editar penalidad"
                                            style="font-size: 12px;">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                    
                                    <!-- Botón eliminar -->
                                    <button data-rbac-permiso="config.comisiones.delete" *ngIf="item.status == true && (_auth.hasPermission('config.comisiones.delete') || _auth.hasAccessOrProfile('finanzas', ['OWNER']))" 
                                            (click)="delete(item?.code)" 
                                            class="btn btn-sm btn-outline-danger p-1"
                                            title="Eliminar penalidad"
                                            style="font-size: 12px;">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Fila completa para el estatus enfatizado -->
                            <div class="row mb-3">
                                <div class="col-12">
                                    <div class="d-flex align-items-center justify-content-between p-2 rounded border" 
                                         [ngClass]="{'bg-light border-success': !item?.paused, 'bg-light border-warning': item?.paused}"
                                         style="background-color: #f8f9fa !important;">
                                        <!-- Lado izquierdo: Etiqueta ESTADO -->
                                        <span class="fw-bold" 
                                              [ngClass]="{'text-success': !item?.paused, 'text-warning': item?.paused}">
                                            ESTADO:
                                        </span>
                                        
                                        <!-- Lado derecho: Toggle y estado actual -->
                                        <div class="d-flex align-items-center">
                                            <div data-rbac-permiso="config.comisiones.update" *ngIf="_auth.hasPermission('config.comisiones.update') || _auth.hasAccessOrProfile('finanzas', ['OWNER'])" class="form-check form-switch me-3">
                                                <input class="form-check-input" 
                                                       type="checkbox" 
                                                       role="switch"
                                                       [checked]="!item?.paused"
                                                       (change)="changeStatus(item?.code, item?.paused)"
                                                       title="{{!item?.paused ? 'Activo' : 'Pausado'}}"
                                                       style="transform: scale(1.2);">
                                            </div>
                                            <span class="fw-bold" 
                                                  [ngClass]="{'text-success': !item?.paused, 'text-warning': item?.paused}">
                                                {{!item?.paused ? 'ACTIVO' : 'PAUSADO'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="mt-1 fw-bold text-start">
                                {{item?.code_concept}}  
                            </div>
                            <div class=" fw-bold text-start">
                                {{item?.name}}  
                            </div>
                            <div class="text-secondary small text-start">
                                {{item?.description}} 
                            </div>
                            

                            <!-- <div class="text-secondary small">
                                Inicio: {{item?.start_date | date: 'dd/MM/yyyy'}} 
                            </div>
                            <div class="text-secondary small">
                                Finalización: {{item?.start_date | date: 'dd/MM/yyyy'}} 
                            </div> -->
                            <!-- <pre>{{ item | json }}</pre> -->
                            <!-- <span class="badge rounded-pill bg-secondary2 me-2 mt-2">Aplica : {{item?.apply==='ACCOUNT'? 'Cuenta': 'Cuota'}}</span>
                            <span class="badge rounded-pill bg-secondary2 me-2 mt-2">Medida : {{item?.type==='credit'? 'Crédito': 'Dia'}}</span>
                             -->
                            <div class="mt-4">
                                <div class="d-flex align-items-center justify-content-between mb-3">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-cogs text-primary me-2"></i>
                                        <h6 class="fw-bold mb-0 text-primary">Reglas de Aplicación</h6>
                                        <span class="badge bg-secondary ms-2">{{item?.fees.length}}</span>
                                    </div>
                                    <!-- Botón para mostrar/ocultar reglas -->
                                    <button class="btn btn-sm btn-outline-primary" 
                                            (click)="toggleRules(item.code)"
                                            *ngIf="item?.fees.length > 0">
                                        <i class="fas" 
                                           [ngClass]="showRulesForFee[item.code] ? 'fa-eye-slash' : 'fa-eye'"></i>
                                        <span class="ms-1">
                                            {{showRulesForFee[item.code] ? 'Ocultar reglas' : 'Ver reglas'}}
                                        </span>
                                    </button>
                                </div>

                                <!-- Reglas con estilo profesional - Solo se muestran si showRulesForFee[item.code] es true -->
                                <div class="row g-2" *ngIf="item?.fees.length > 0 && showRulesForFee[item.code]">
                                    <div class="col-12" *ngFor="let elem of item.fees; let i = index">
                                        <div class="card border-0 shadow-sm mb-2" style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);">
                                            <div class="card-body p-3">
                                                <!-- Header de la regla -->
                                                <div class="d-flex align-items-start justify-content-between mb-2">
                                                    <div class="d-flex align-items-center">
                                                        <span class="badge bg-primary bg-opacity-10 text-primary me-2" style="font-size: 9px;">
                                                            #{{i + 1}}
                                                        </span>
                                                        <span class="text-muted small" style="font-size: 9px;">
                                                            {{ elem.code ?? elem.uuid }}
                                                        </span>
                                                    </div>
                                                    <div class="text-end">
                                                        <div class="fw-bold text-success" style="font-size: 14px;">
                                                            <span *ngIf="elem.fixed_amount">{{ elem.currency }} {{ elem.fixed_amount }}</span>
                                                            <span *ngIf="elem.percentage">
                                                                <span *ngIf="elem.fixed_amount" class="text-muted"> + </span>{{ elem.percentage }}%
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Condición de la regla -->
                                                <div class="mb-2">
                                                    <div class="d-flex align-items-center">
                                                        <i class="fas fa-filter text-info me-2" style="font-size: 12px;"></i>
                                                        <span class="fw-medium text-dark" style="font-size: 13px;">
                                                            <ng-container *ngIf="elem.withCondition==null || elem.withCondition==true">
                                                                {{ getValueByKey(list_fee_attributes,elem.attribute) }} 
                                                                <span class="text-primary fw-bold">{{ getValueByKey(list_comparison, elem.condition) }}</span>
                                                                <span class="text-success fw-bold" *ngIf="elem.condition=='BETWEEN'">
                                                                    {{ elem.lower_limit }} y {{ elem.upper_limit }}
                                                                </span>
                                                                <span class="text-success fw-bold" *ngIf="elem.condition!='BETWEEN'">
                                                                    {{ elem.single_value }}
                                                                </span>
                                                            </ng-container>
                                                            <ng-container *ngIf="elem.withCondition==false">
                                                                <span class="text-info">Sin condiciones específicas</span>
                                                            </ng-container>
                                                        </span>
                                                    </div>
                                                </div>

                                                <!-- Badges de estado y aplicación -->
                                                <div class="d-flex flex-wrap gap-1 mb-2">
                                                    <span class="badge bg-success small">Activo</span>
                                                    <span class="badge bg-secondary small" *ngIf="elem.start_date <= now">Programado</span>
                                                    <span *ngIf="elem.applies_reactivation" class="badge bg-info small">Reactivación</span>
                                                    <span *ngIf="elem.applies_update_recalc" class="badge bg-warning text-dark small">Recálculo</span>
                                                </div>

                                                <!-- Vigencia -->
                                                <div class="d-flex align-items-center text-muted">
                                                    <i class="fas fa-calendar-alt me-2" style="font-size: 11px;"></i>
                                                    <small>
                                                        Vigente desde {{ elem.start_date | date: 'dd/MM/yyyy' }}
                                                        <span *ngIf="elem.end_date"> hasta {{ elem.end_date | date: 'dd/MM/yyyy' }}</span>
                                                        <span *ngIf="!elem.end_date" class="text-success"> (Sin límite)</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Estado vacío mejorado -->
                                <div class="text-center py-4" *ngIf="item?.fees.length === 0 && showRulesForFee[item.code]">
                                    <div class="card border-0 bg-light">
                                        <div class="card-body">
                                            <i class="fas fa-inbox text-muted mb-2" style="font-size: 24px;"></i>
                                            <p class="text-muted mb-0">No se han configurado reglas de aplicación</p>
                                            <small class="text-muted">Esta penalidad necesita reglas para poder aplicarse</small>
                                        </div>
                                    </div>
                                </div>

                                <!-- Mensaje compacto cuando no hay reglas y están ocultas -->
                                <div class="text-center py-2" *ngIf="item?.fees.length === 0 && !showRulesForFee[item.code]">
                                    <small class="text-muted">
                                        <i class="fas fa-info-circle me-1"></i>
                                        No hay reglas configuradas
                                    </small>
                                </div>
                            </div>

                            <div class="mt-4 small" *ngIf="item?.fee?.account_payment">
                                <span class="fw-bold">Cuenta contable SAP</span><br>
                                <span class="">Suscriptor: {{ item?.fee?.account_payment?.subscriptor_cuenta }} </span>; 
                                <span class="">Suscriptor simbolo: {{ item?.fee?.account_payment?.subscriptor_simbolo }}</span>; 
                                <span class="">Suscriptor MP: {{ item?.fee?.account_payment?.subscriptor_mp }}</span>; 
                            </div>
                            <div class="text-end small text-secondary">
                                Por: {{item?.user?.name }} {{item?.user?.lastName }} 
                            </div>

                            <!-- <pre>{{ item | json }}</pre> -->

                        </div>
                      </div>
                    </div>


                </div>

                


             


            </ng-container>


            <div *ngIf="!plans_loading && !plans">
                <div>No se encontraron planes </div>
            </div>

            <ng-container *ngIf="plans_loading ">
                <div class="w-100 text-center mt-2">
                    <img src="./assets/public/images/loading.gif  " alt=" ">
                </div>
            </ng-container>


        </div>
    </div>

</div>

<!-- Version Timeline Component -->
<app-version-timeline 
  *ngIf="showVersionTimeline"
  [codeConcepto]="selectedCodeConcept"
  [isVisible]="showVersionTimeline"
  (closeEvent)="closeVersionTimeline()"
  (viewDetailsEvent)="openVersionDetail($event)">
</app-version-timeline>

<!-- Version Detail Component -->
<app-version-detail 
  *ngIf="showVersionDetail"
  [versionId]="selectedVersionId"
  [isVisible]="showVersionDetail"
  (closeEvent)="closeVersionDetail()"
  (backToTimelineEvent)="backToTimeline()">
</app-version-detail>